import rawProvinces from "provinces";

const provinces = (() => {
  return rawProvinces.reduce((result, province) => {
    // Initialize the country array if it doesn't exist
    if (!result[province.country]) {
      result[province.country] = [];
    }
    // Add the province to the corresponding country array
    result[province.country].push(province);
    return result;
  }, {});
  return;
})();

const filteredStates = ["DC", "AS", "GU", "MP", "PR", "UM", "VI"];

const states = (() => {
  return provinces.US.filter((item) => !filteredStates.includes(item.short));
})();

export { provinces, states, filteredStates };
